import { Box, Dialog, IconButton, styled, Typography } from "@mui/material";
import React, { useState } from "react";
import Close from "../assets/svg/Close";
import TextFieldBox from "./common/TextField";
import CustomButton from "./common/CustomButton";
import { API_ROUTES } from "../utils/Api/ApiConfig";
import { apiPatch, apiPut } from "../utils/Api/ApiCalls";

function CloseCall({
  open,
  setOpen,
  selectedCall,
  setCallData,
  callsname,
  closeCallApiType,
  fetchCallData,
}) {
  const [formData, setFormData] = useState({
    reason: "",
    price: null,
  });
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const handleChange = (field) => (event) => {
    const value = event.target.value;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [field]: field === "reason" ? value : parseFloat(value) || 0, // Parse value as a number
      };

      return updatedData;
    });
  };
  const validateForm = () => {
    let newErrors = {};

    if (!formData.reason.trim()) newErrors.reason = "reason are required.";
    if (!formData.price || isNaN(formData.price))
      newErrors.price = "Entry Price must be a valid number.";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const handleCloseCallClick = async (_id) => {
    const body = {
      callId: _id,
      targetIds: [],
      status: "Closed",
      exitPrice: formData.price,
      exitReason: formData.reason,
      action: `Exit Price : ${formData?.price} , Reason : ${formData?.reason}. `,
      title: `Exit : ${callsname}`,
    };
    setLoader(true);

    try {
      // const response = await apiPut(API_ROUTES.PUT_CALLS, body);
      // if (response?.status === 200) {
      //   setCallData((prev) => {
      //     const a = [...prev]
      //       .flat()
      //       ?.filter((call) => call._id !== response?.data.call._id);
      //     a.unshift(response?.data?.call);
      //     console.log(a);
      //     return a;
      //   });
      //   setLoader(false);
      //   setOpen(false);
      //   setFormData({
      //     reason: "",
      //     price: null,
      //   });
      // }
      let response;
      // const response = await apiPut(API_ROUTES.PUT_CALLS, body);
      if (closeCallApiType === "default") {
        response = await apiPut(API_ROUTES.PUT_CALLS, body); // 👈 First page API
        if (response?.status === 200) {
          setCallData((prev) => {
            const a = [...prev]
              .flat()
              ?.filter((call) => call._id !== response?.data.call._id);
            a.unshift(response?.data?.call);
            console.log(a);
            return a;
          });
          setLoader(false);
          setOpen(false);
          setFormData({
            reason: "",
            price: null,
          });
        }
      } else if (closeCallApiType === "second") {
        response = await apiPatch(API_ROUTES.EDIT_CALL, {
          callIds: [_id],
          action: "closed",
        });
        // 👈 Second page API
      }
      // setCallData((prev) => {
      //   const a = [...prev]
      //     .flat()
      //     ?.filter((call) => call._id !== response?.data.call._id);
      //   a.unshift(response?.data?.call);
      //   console.log(a);
      //   return a;
      // });
      setLoader(false);
      setOpen(false);
      fetchCallData();
      setFormData({
        reason: "",
        price: null,
      });
      setLoader(false);
    } catch (err) {
      console.log(err);
      setLoader(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      handleCloseCallClick(selectedCall._id);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setFormData({
      reason: "",
      price: null,
    });
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: "1rem" } }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          padding: "1rem",
          rowGap: "1.5rem",
          position: "relative",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: "0",
            right: "0",
            padding: "0.5rem",
          }}
        >
          <Close />
        </IconButton>
        <Typography
          sx={{ fontSize: 20, fontWeight: 600, marginBottom: "0.5rem" }}
        >
          Close Calls
        </Typography>
        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", rowGap: "1.5rem" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              rowGap: "0.5rem",
            }}
          >
            <Typography>Exit Price</Typography>
            <TextFieldContainer>
              <Box
                sx={{ display: "flex", width: "100%", alignItems: "center" }}
              >
                <RupeeContainer>
                  <Typography>₹</Typography>
                </RupeeContainer>
                <TextFieldBox
                  type="number"
                  value={formData.price}
                  onChange={handleChange("price")}
                  placeholder="Enter Exit Price"
                />
              </Box>
              {errors.price && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ marginTop: "0.5rem", ml: "3.5rem" }}
                >
                  {errors.price}
                </Typography>
              )}
            </TextFieldContainer>
          </Box>
          <Box
            sx={{ display: "flex", flexDirection: "column", rowGap: "0.5rem" }}
          >
            <Typography variant="h6">Reason for Call Close</Typography>
            <TextFieldBox
              value={formData.reason}
              onChange={handleChange("reason")}
              multiline
              placeholder="Enter reason"
              rows={4}
              error={!!errors.reason}
              helperText={errors.reason}
            />
          </Box>
          <Box display={"flex"} columnGap={"1rem"} width={"50%"}>
            <CustomButton
              title="Close Call"
              variant="contained"
              type="submit"
              loading={loader}
              fullWidth
              sx={{
                backgroundColor: "#FFC200",
                color: "white",
                textTransform: "capitalize",
                borderRadius: "8px",
              }}
            />
            <CustomButton
              title="Close"
              variant="outlined"
              fullWidth
              handleClick={handleClose}
              sx={{
                borderColor: "#ACACAC",
                color: "#606067",
                textTransform: "capitalize",
                borderRadius: "8px",
              }}
            />
          </Box>
        </form>
      </Box>
    </Dialog>
  );
}

export default CloseCall;
const RupeeContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "0.5rem 1rem",
  backgroundColor: "#FFF9E6",
  borderTopLeftRadius: 8,
  borderBottomLeftRadius: 8,
}));
const TextFieldContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
}));
